import React from 'react';
import Star from '../assets/icons/star.png';
import StarFill from '../assets/icons/star-fill.png';
import HalfStar from '../assets/icons/half-star.png';

export const getRatingSummary = (reviews) => {
    const total = reviews?.length || 0;
    const counts = { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 };
    let overallSum = 0;

    reviews?.forEach(r => {
        const rating = Math.round(r.totalRating);
        counts[rating] = (counts[rating] || 0) + 1;
        overallSum += r.totalRating;
    });

    const distribution = {};
    Object.keys(counts).forEach(star => {
        distribution[star] = total ? Math.round((counts[star] / total) * 100) : 0;
    });

    const overallRating = total ? overallSum / total : 0;
    return { overallRating, total, distribution };
};

export const renderStars = (rating, size = 15, marginRight = 2) => {
    const rounded = Math.round(rating * 2) / 2;

    return [...Array(5)].map((_, i) => {
        const diff = rounded - i;
        const src = diff >= 1 ? StarFill : diff === 0.5 ? HalfStar : Star;
        const alt = diff >= 1 ? "star filled" : diff === 0.5 ? "half star" : "star";

        return (
            <img
                key={i}
                src={src}
                alt={alt}
                style={{ width: size, height: size, marginRight }}
            />
        );
    });
};

export const RecaptchaConfig = {
    RECAPTCHA_SITE_KEY: "6Leer9MrAAAAAPBwU8qLaPY9ARdibHh5uCRGGiWG",
};

export const reviewStatusMap = Object.freeze({
    1: "Approved",
    2: "Rejected",
    3: "Save for Later",
});

export const schoolVerificationMap = Object.freeze({
    1: "School Verified",
    2: "Non School Verified",
});